//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vModal from '@/core/vModal'
import { mapGetters } from 'vuex'
export default {
  name: 'MemberLevelModal',
  extends: vModal,
  props: {
    info: {
      type: Object,
      default: () => { return null }
    }
  },
  data () {
    return {
      currentModal: { // 正在開啟update的欄位
        title: '會員等級',
        fieldName: '',
        val: ''
      },
      levelOptions: [
        { label: '0', value: '0' },
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'site',
      'stock_no',
      'theme',
      'builderHost',
      'dateFormat'
    ])
  },
  async created () {
    this.levelOptions = [
      { label: this.getMemberLabel('0'), value: '0' },
      { label: this.getMemberLabel('1'), value: '1' },
      { label: this.getMemberLabel('2'), value: '2' },
      { label: this.getMemberLabel('3'), value: '3' }
    ]
  },
  mounted () {
  },
  watch: {
    isVisible (val) {
      if (val) {
        if (this.info !== null) this.currentModal.val = this.info.MEMBER_LEVEL
      }
    }
  },
  methods: {
    alert (message) {
      this.$q.dialog({
        message
      }).onOk(() => {
        this.close()
      })
    },
    clickUpdate () {
      if (this.currentModal.val === '' || this.currentModal.val === null) {
        this.alert('請選擇修改等級!!')
      } else {
        this.doSave()
      }
    },
    async doSave () {
      console.log('this,info=')
      console.log(this.info)
      const val = parseInt(this.currentModal.val.value)
      const data = { baseLevel: val }
      const response = await this.fetch('levelUpdate', this.site, this.info.ID_NO, data)
      if (response.result === 'OK') {
        this.alert('修改成功！！')
        this.emit('InfoPage.CMD_UpdateInfo')
      } else {
        this.alert(`發送失敗！！${response.msg}`)
      }
    },
    getMemberLabel (val) {
      let str = ''
      switch (val) {
        case '0':
          str = '一般會員'
          break
        case '1':
          str = '會員一'
          break
        case '2':
          str = '會員二'
          break
        case '3':
          str = '會員三'
          break
      }
      return str
    }
  }
}
